export const getMrnLabel = (useMpiLabel?: boolean): string => (useMpiLabel ? 'MPI' : 'MRN');
